import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { chageEstadoAranceles, getAranceles } from "../../../API/IMEX/IMEXRequest";
import ArancelesCRUD from "./ArancelesCRUD";
import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { toastShow } from "../../../Base/Services/ToastService";

// ------------------ COMPONENTES DE NECESARIOS--------------------------


const MestrosScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [selected, setSelected] = useState([])
  const [estados, setEstados] = useState([])
  
  const getInfo = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo)
    let result;
    switch (activeIndex) {
      case 0:
        result = await getAranceles();
        break;
      default:
        console.warn('Invalid activeIndex');
        setLoading(false);
        return;
    }

    setData(result);
    setLoading(false);
  };

  const openDialog = () => {
    switch (activeIndex) {
      case 0:
        setShowDialog(true); 
        break;
      default:
        console.warn('Invalid index for dialog');
        break;
    }
  };
 
  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          placeholder="Estados"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdArancel: item.IdArancel,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdArancel: data.IdArancel,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} ${changes.length} ${changes.length > 1 ? 'Aranceles' : 'Arancel'}?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdAranceles = changes.map((item) => item.IdArancel);
                cambiarEstado(e.value.IdStatus, IdAranceles.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdAranceles) => {
    const result = await chageEstadoAranceles({ IdStatus, IdAranceles });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };


  const colums = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdArancel',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        if(!data?.IdArancel) return;
        setSelected([data])
        setShowDialog(true)
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
      cellEditor: changeEstado,
      editable: (e) => e.data?.IdArancel ? true : false,
    },
    {
      header: 'Código',
      headerEn: 'Code',
      frozen: true,
      Sumary: 'count',
      field: 'Codigo',
      onCellDoubleClicked: ({ data }) => {
        if(!data?.IdArancel) return;
        setSelected([data])
        setShowDialog(true)
      },
      className: 'small',
      Format: 'Modal'
    },
    {
      header: 'Arancel',
      headerEn: 'Tariff',
      field: 'Arancel',
      flex: 1,
      minWidth:500,
      onCellDoubleClicked: ({ data }) => {
        if(!data?.IdArancel) return;
        setSelected([data])
        setShowDialog(true)
      },
    },
    {
      header: 'DAI',
      headerEn: 'DAI',
      field: 'Comentario',
      onCellDoubleClicked: ({ data }) => {
        if(!data?.IdArancel) return;
        setSelected([data])
        setShowDialog(true)
      },
      className: 'large',
    },
    // {
    //   header: 'Usuario Creación',
    //   headerEn: 'User Create',
    //   field: 'UserNameCreate',
    //   className: 'medium',
    // },
    // {
    //   header: 'Usuario Creación',
    //   headerEn: 'User Create',
    //   field: 'UserNameCreate',
    //   className: 'medium',
    // },
    // {
    //   header: 'Usuario Edición',
    //   headerEn: 'User Edit',
    //   field: 'UserNameEdit',
    //   className: 'medium',
    // },
    // {
    //   field: "DateEditStr",
    //   header: "Fecha Edición",
    //   headerEn: "Edit Date",
    //   className: "medium",
    //   Format: "DateTime",
    // },
    {
      field: "IdArancel",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdArancel){
              if(!rowData?.IdArancel) return;
              setSelected([rowData])
              setShowDialog(true)
            }
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ]

  const table = {
    Columns: colums,
    Data: data,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {}
  }

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "Maestros", config.language));
  }, [activeIndex]);
  
  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "Maestros", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            <Button
              icon="pi pi-plus"
              tooltip="Nuevo"
              onClick={(e) => openDialog()}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header={getLabel(baseLang, "Aranceles", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

    {showDialog && (
      <ArancelesCRUD
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        selected={selected}
        setSelected={setSelected}
        getInfo={getInfo}
      />
    )}


    </div>
  );
};

export default MestrosScreen;
